<template>
    <div class="flex flex-col gap-y-6">
        <DetailedListItem
            v-if="listDesign === 'detailed'"
            v-for="item in listItems"
            :key="item.id"
            :item="item"
            :resourceable-model-class="'resource'"
            displayVariant="maincolumn"
            :class="[
                'first:border-t-0 border-t pt-6 first:pt-0',
                `border-${modelClass}-accent`,
            ]"
            :showOptionsButton="true"
            panelModalClass="resource"
        />

        <component
            v-else
            :is="listDesign === 'numbered' ? 'ol' : 'ul'"
            :class="[
                { 'list-decimal': listDesign === 'numbered' },
                { 'list-disc': listDesign === 'bulleted' },
                'flex flex-col gap-y-4 list-inside',
            ]"
        >
            <li v-for="item in listItems" :key="item.id">
                <Link
                    :href="item.url"
                    v-text="item.name"
                    class="text-lg font-header font-medium underline-hover text-link"
                />
            </li>
        </component>
    </div>
</template>

<script>
import DetailedListItem from '@/Components/Panels/DetailedListItem.vue'
import { Link } from '@inertiajs/vue3'

export default {
    name: 'ResourceList',

    components: {
        DetailedListItem,
        Link,
    },

    props: {
        listDesign: {
            type: String,
            default: 'detailed',
            validator: (value) =>
                ['detailed', 'numbered', 'bulleted'].includes(value),
        },
        listItems: {
            type: Array,
            required: true,
            default: () => [],
        },
        modelClass: {
            type: String,
            default: 'resource',
        },
    },
}
</script>
